import type { InputPuzzle } from "./puzzle.types";

export const PROTEGE_PUZZLES: InputPuzzle[] = [
  {
    p: "024680050080000200056002091000205603600000000005000020900803504043000068510090000",
    s: "124689357789531246356742891491275683632918475875364129967823514243157968518496732",
    d: -5324,
  },
  {
    p: "000850900073940000608307000300094007487205309902038600009003006200080700700001508",
    s: "124856973573942861698317452365194287487265319912738645849573126251689734736421598",
    d: -5279,
  },
  {
    p: "004900075700120900000008100600370580975680000013590020060039050490000000500000007",
    s: "124963875786125943359748162642371589975682314813594726267839451491257638538416297",
    d: -5114,
  },
  {
    p: "000060300643970000809030050308600420000000130250040090400109000910003280000000000",
    s: "125864379643975812879231654398617425764592138251348796487129563916453287532786941",
    d: -5127,
  },
  {
    p: "000000600000000490000653082790361000600508720548700000907006010030907000800200904",
    s: "125894637386172495479653182792361548613548729548729361957486213234917856861235974",
    d: -5114,
  },
  {
    p: "020073040034602001780045030000010004871009060000000003400007328200300600007800050",
    s: "125973846934682571786145932593216784871439265642758193419567328258394617367821459",
    d: -5114,
  },
  {
    p: "020000040004800060905000301000520090010090800490300500070004900000005137800000406",
    s: "128653749734819265965742381387521694512496873496378512273164958649285137851937426",
    d: -5490,
  },
  {
    p: "000000504040006380906000000000091856305700040080050007000009620209180000703020000",
    s: "128937564547216389936845712472391856395768241681452937814579623269183475753624198",
    d: -5127,
  },
  {
    p: "100970030000010987079030040010200378302007400005040006830760504040300009500000060",
    s: "128974635453612987679538142914256378362897451785143296831769524246385719597421863",
    d: -5544,
  },
  {
    p: "000970400064230007500408009702310084081520300050007900005000600300000000000703001",
    s: "128975463964231857537468129792316584481529376653847912275194638319682745846753291",
    d: -5532,
  },
  {
    p: "100070005680000000030050100312004700050000800006039400008300002790405680260798000",
    s: "129876345685143297437952168312684759954217836876539421548361972791425683263798514",
    d: -5114,
  },
  {
    p: "032004000900386020078010003209700060010052307300901050700020906003007000020093800",
    s: "132574689945386721678219543259738164814652397367941258781425936593867412426193875",
    d: -5544,
  },
  {
    p: "030097000000300297500000306628900000000500062001862043000036008803020704000700630",
    s: "132697485486315297597284316628943571349571862751862943975436128863129754214758639",
    d: -5322,
  },
  {
    p: "030000560900065001005002040050029078801000026279100000000230095603000002020090003",
    s: "132948567984765231765312849356429178841573926279186354418237695693854712527691483",
    d: -5114,
  },
  {
    p: "134870050009040003050001008800059002701000005502310897006003000300500200405000630",
    s: "134872956289645713657931428843759162791268345562314897976423581318596274425187639",
    d: -5544,
  },
  {
    p: "100060082004000003000400705060380200000600859092704000000506040056248130000003000",
    s: "135967482724815693689432715561389274347621859892754361213576948956248137478193526",
    d: -5532,
  },
  {
    p: "030000800240006137000000040713602009080300000400000700802400300004160298590023406",
    s: "137294865249586137658731942713642589985317624426958713862479351374165298591823476",
    d: -5544,
  },
  {
    p: "037002005542670010089000070006100004000007021400000850060001089008030067050800032",
    s: "137982645542673918689514273326158794895467321471329856263741589918235467754896132",
    d: -5322,
  },
  {
    p: "000000406020468030000000702700000203290031000360284005602843007078600020000002064",
    s: "139527486527468139846319752784956213295731648361284975612843597478695321953172864",
    d: -5544,
  },
  {
    p: "140003000000000384008460070700030006200690100000080903067049500030000409004350000",
    s: "142873695675912384398465271759231846283694157416587923867149532531728469924356718",
    d: -5324,
  },
  {
    p: "000900000000000500086073092007086003800000010231749000008000060370060049600320750",
    s: "143952876792618534586473192957186423864235917231749685428597361375861249619324758",
    d: -5532,
  },
  {
    p: "000072908300006105006008000004000000519060000063129057050000036070000500438050090",
    s: "145372968387496125296518374724835619519764283863129457951247836672983541438651792",
    d: -5532,
  },
  {
    p: "100800703030400051000000064800000000604701308200540076012600007007003019069107030",
    s: "145869723936472851728315964871936245654721398293548176312694587487253619569187432",
    d: -5544,
  },
  {
    p: "100000809950018000300000076580906000003500000204700560000000081600004003830169045",
    s: "146327859957618432328495176581946327763582914294731568479253681615874293832169745",
    d: -5114,
  },
  {
    p: "046309800090058607050026093060200900030800756480760200010000062000080300000002400",
    s: "146379825392158647758426193567213984231894756489765231813947562624581379975632418",
    d: -5544,
  },
  {
    p: "006080002050007369900600801602500078085206903010000520800050000520068034061900080",
    s: "146389752258417369973625841692531478485276913317894526834152697529768134761943285",
    d: -5515,
  },
  {
    p: "000590703708203065305070480050004001030000570080000046070005602560807000009406807",
    s: "146598723798243165325671489657384291432169578981752346874915632563827914219436857",
    d: -5279,
  },
  {
    p: "140000605000050020260901870400308500601005000800700910084003000000600302006000009",
    s: "148237695739856421265941873492318567671495238853762914984123756517689342326574189",
    d: -5324,
  },
  {
    p: "100570062906048030070000040090036470002400096360007080007814009009000000600090010",
    s: "148573962926148537573629148891236475752481396364957281237814659419765823685392714",
    d: -5322,
  },
  {
    p: "100360700200000105000100643000003084800004200003820507060008050087236009000050006",
    s: "149365728236487195758192643672513984895674231413829567961748352587236419324951876",
    d: -5114,
  },
  {
    p: "100003400093700001074502603030000820006100005700009306010007530000000974400300102",
    s: "152963487693784251874512693531476829926138745748259316219647538365821974487395162",
    d: -5322,
  },
  {
    p: "150000270004000000000010905200000080680000007000500004070450360436098052008070410",
    s: "153849276794625831862713945247961583685234197319587624971452368436198752528376419",
    d: -5324,
  },
  {
    p: "004090068730460050006057903900706000003010007001900600500623000460000305008000070",
    s: "154392768739468152826157943945736821683214597271985634517623489462879315398541276",
    d: -5114,
  },
  {
    p: "100000802602018900903200400500140070807005004200070090700500380460739001005680709",
    s: "154397862672418953983256417539142678817965234246873195791524386468739521325681749",
    d: -5515,
  },
  {
    p: "054030000027000000800904100002007001740102368001000074000000006096070012070310005",
    s: "154738629927561483863924157632847591749152368581693274415289736396475812278316945",
    d: -5532,
  },
  {
    p: "050000600800001073302409008001006000020043080000120406500800002243705810000002047",
    s: "157238694894651273362479158431986725726543981985127436579814362243765819618392547",
    d: -5322,
  },
  {
    p: "150000000240603071700002400076000234980306015400000090807030040090160007005700100",
    s: "158479362249653871763812459576981234982346715431527698817235946394168527625794183",
    d: -5544,
  },
  {
    p: "100403702207106540069072010020050000004608000080000051000205604092000300040700000",
    s: "158493762237186549469572813723951486514628937986347251871235694692814375345769128",
    d: -5114,
  },
  {
    p: "100643000300050084009078003400182075000400008900500421000819000013000800000324010",
    s: "158643297372951684649278153436182975521497368987536421764819532213765849895324716",
    d: -5544,
  },
  {
    p: "108020000000000019920170000705809021200005040810000007501000803009003050080060000",
    s: "158924736467358219923176485735849621296715348814632597541297863679483152382561974",
    d: -5127,
  },
  {
    p: "159700048008940205400000090520600010000030800000400002040306107600800420097024050",
    s: "159762348378941265462583791523678914914235876786419532245396187631857429897124653",
    d: -5544,
  },
  {
    p: "102049037700806920850000000003070060900008000000420010000700002007090000080001004",
    s: "162549837734816925859237146413975268925168473678423519391784652547692381286351794",
    d: -5295,
  },
  {
    p: "102000800007600009040072605015009004400031000000000000050720400078005201090300708",
    s: "162953847537684129849172635715269384486531972923847516651728493378495261294316758",
    d: -5324,
  },
  {
    p: "000009403024500600000040070605073000230610090009002036000401580000705001051308009",
    s: "167289453924537618583146972615973824238614795479852136396421587842795361751368249",
    d: -5322,
  },
  {
    p: "160095400000006000000003061000067009090200080236004705040008003700509000609032004",
    s: "168795432324816957975423861851367249497251386236984715542678193713549628689132574",
    d: -5532,
  },
  {
    p: "009500807057006923004800056035090018000107000091308000010900000943000001000200095",
    s: "169532847857416923324879156235694718486127539791358462512983674943765281678241395",
    d: -5322,
  },
  {
    p: "000009006300020000009003200700641005610090740000035619080000062031080004560902008",
    s: "172459386356827491849163257793641825615298743428735619987314562231586974564972138",
    d: -5322,
  },
  {
    p: "072834069045020008000075020014080000867040003200300800523408000000003080486007310",
    s: "172834569945126738638975421314789652867542193259361847523418976791653284486297315",
    d: -5515,
  },
  {
    p: "002080000000200070000047010046100090083000127207098400001029060008650001005003900",
    s: "172986543854231679369547812546172398983465127217398456431829765798654231625713984",
    d: -5532,
  },
  {
    p: "000500000069083010083000059025300164730001020001200000000006590000050708057009000",
    s: "174592386569483217283617459925378164736941825841265973418736592692154738357829641",
    d: -5324,
  },
  {
    p: "104000060000701003600085070400006015016078300050002706060234050041050607502000000",
    s: "174923568825761493639485172487396215216578349953142786768234951341859627592617834",
    d: -5544,
  },
  {
    p: "000030698003000200020197000201000059400000026700020300004080002682903001000002043",
    s: "175234698943856217826197435231468759458379126769521384314785962682943571597612843",
    d: -5532,
  },
  {
    p: "000002906008005000000063700516080040027504160900020050209000070000478003083009600",
    s: "175842936368795421492163785516987342827534169934621857249316578651478293783259614",
    d: -5114,
  },
  {
    p: "100500089004008700000040100040050930000060270507009604003614000419005060062900040",
    s: "176532489234198756985746123641257938398461275527389614753614892419825367862973541",
    d: -5322,
  },
  {
    p: "106020000090603008583470000400006807010000260807030005000900000901058400035001000",
    s: "176825349294613758583479621452196837319587264867234195748962513921358476635741982",
    d: -5532,
  },
  {
    p: "076890000809040300040600000008500231200000705457200980004350090930006002000009073",
    s: "176893524829145367345627819698574231213968745457231986764352198931786452582419673",
    d: -5544,
  },
  {
    p: "070400020902080001000900075095000038003000050000538004041009067000000512000203489",
    s: "178465923952387641634921875495672138823194756716538294241859367389746512567213489",
    d: -5114,
  },
  {
    p: "182576009400090005005030700300700000521009004800021060000200906000980001219000000",
    s: "182576439473892615965134728346758192521369874897421563758213946634987251219645387",
    d: -5114,
  },
  {
    p: "182605040000042000049030820050009000900006004000050980000070136096013008803060700",
    s: "182695347375842619649731825457389261938126574261457983524978136796213458813564792",
    d: -5322,
  },
  {
    p: "000090000502008000000150408640010802009230010251000700400009500305706000060041080",
    s: "184692375532478196796153428643917852879235614251864739418329567325786941967541283",
    d: -5532,
  },
  {
    p: "000000674230000001904005803000830000001500900320001008000040085518007000493158002",
    s: "185293674237486591964715823759834216841562937326971458672349185518627349493158762",
    d: -5322,
  },
  {
    p: "085000000047010300029487000000700030000090756706040001070060500000520604064170203",
    s: "185632947647915328329487165891756432432891756756243891278364519913528674564179283",
    d: -5322,
  },
  {
    p: "107300009000409005090060000000001003708000290051082004500006008209807506816500307",
    s: "187325469623479185495168732962741853748653291351982674574236918239817546816594327",
    d: -5544,
  },
  {
    p: "080400300020600080006013002800360900005000000460902108200100060001089000507000800",
    s: "189427356324695781756813492872361945915748623463952178238174569641589237597236814",
    d: -5127,
  },
  {
    p: "080000006600000094000003508050701062910030087070600059300500071501007900702000040",
    s: "189452736635178294427963518854791362916235487273684159348529671561847923792316845",
    d: -5114,
  },
  {
    p: "100406730074000000230700100840017320060000000001643500008069270703000061000100803",
    s: "189456732574231698236798154845917326367582419921643587418369275753824961692175843",
    d: -5544,
  },
  {
    p: "100758204280430000000106030060590100400003592008000000000060010019800307004010000",
    s: "193758264286439751745126839362594178471683592958271643837962415619845327524317986",
    d: -5532,
  },
  {
    p: "090078043203000007070000000320605070507402081000087205700006008030020009951003000",
    s: "195278643283164597674539812328615974567492381419387265742956138836721459951843726",
    d: -5322,
  },
  {
    p: "000020003000010502230580069040200030018070094002040080724000000050400306960850000",
    s: "195726843486913572237584169549268731618375294372149685724631958851497326963852417",
    d: -5114,
  },
  {
    p: "196780240850034000000001050020000006000040070400823000003409060005300901000010530",
    s: "196785243852934617734261859321597486589146372467823195213459768645378921978612534",
    d: -5532,
  },
  {
    p: "090306200200948713008000659072000008500890076080760005813600497020009000009030000",
    s: "197356284265948713348271659672513948534892176981764325813625497726489531459137862",
    d: -5515,
  },
  {
    p: "097003502400028070005009006079001008060004000000200067683012750000040001004000023",
    s: "197463582436528179825179436579631248268794315341285967683912754752346891914857623",
    d: -5114,
  },
  {
    p: "007003520206095008485700030500300000600080207800006001701000005364000700008400003",
    s: "197843526236195478485762139572319864613584297849276351721638945364951782958427613",
    d: -5114,
  },
  {
    p: "000020070207000900036007804900750000070009106312400507053000009009176003001000400",
    s: "198324675247685931536917824964751382875239146312468597653842719489176253721593468",
    d: -5114,
  },
  {
    p: "203000900094000060508410020007603849040070502002000006000050400800094250005230000",
    s: "213567984794382165568419327157623849649178532382945716921856473836794251475231698",
    d: -5114,
  },
  {
    p: "000009036070003418006500070060204703000708000000005900020000845948000000003087000",
    s: "214879536579623418836541279165294783392718654487365921721936845948152367653487192",
    d: -5127,
  },
  {
    p: "004000000000600002007030840020008400400009081008403765900307514040050000705900006",
    s: "214895637839674152657132849526718493473569281198423765962387514341256978785941326",
    d: -5532,
  },
  {
    p: "200430009867195432390802050000060000000900013000218005086000704420000560000000090",
    s: "215436879867195432394872156142563987658947213739218645986351724423789561571624398",
    d: -5544,
  },
  {
    p: "000003000893004000400052108708009060609018000530006809060820015000360700080090006",
    s: "215683497893174652476952138748539261629718543531246879364827915952361784187495326",
    d: -5322,
  },
  {
    p: "000894700000000409390700002001529067000000040060010000080002090600943018040605000",
    s: "215894736876231459394756182431529867752368941968417325583172694627943518149685273",
    d: -5324,
  },
  {
    p: "010903400970025001806400200000040350050100608640000000000208503007000000301004086",
    s: "215983467974625831836417295198746352752139648643852179469278513587361924321594786",
    d: -5532,
  },
  {
    p: "210307080930520600500000000480030070721009003000000094050070900000200760007950320",
    s: "216347589934528617578691432489135276721469853365782194652873941893214765147956328",
    d: -5114,
  },
  {
    p: "210000030608070100000000700000014000074500008800002490401325007080041203320680500",
    s: "217459836648273159593168742932814675174596328856732491461325987785941263329687514",
    d: -5322,
  },
  {
    p: "209030004058200900000015380000053190097100035000706420625009001000001000000080500",
    s: "219638754358247916746915382462853197897124635531796428625379841984561273173482569",
    d: -5114,
  },
  {
    p: "009000300005007100700610900041902000800006009090030025400721500000008040006009030",
    s: "219845367365297184784613952541982673823576419697134825438721596952368741176459238",
    d: -5127,
  },
  {
    p: "000060700503000800070025100080140309900036000024090001000600280792300010000057030",
    s: "219863745543971862876425193687142359951736428324598671435619287792384516168257934",
    d: -5532,
  },
  {
    p: "034605000089300500010209000000004008071000030900800100703450020000006001000000746",
    s: "234615987689347512517289463356174298871592634942863175763451829498726351125938746",
    d: -5490,
  },
  {
    p: "030009060080001090710080500000004080002810609000600070003208040468000020000943016",
    s: "234759168685321497719486532976534281342817659851692374193268745468175923527943816",
    d: -5532,
  },
  {
    p: "000800000090030600006004003060200408307000010004650030100008267870500000640107380",
    s: "235816974498735621716924853561273498327489516984651732159348267873562149642197385",
    d: -5532,
  },
  {
    p: "030090800004583001008002003301004002007300148800016030009060000060000000000978500",
    s: "236197854974583261518642793391854672657329148842716935189465327765231489423978516",
    d: -5324,
  },
  {
    p: "230160000069050000000004300106007040000001903840006050020019007004203005000000280",
    s: "237168594469352178518794326196537842752481963843926751625819437984273615371645289",
    d: -5127,
  },
  {
    p: "030100050009500100100092400400000930002400080000810200520030006304000702678200000",
    s: "237184659849576123165392478486725931912463587753819264521937846394658712678241395",
    d: -5324,
  },
  {
    p: "000006005090580000581000069060005000012804000900210040045600907000052080300409000",
    s: "237946815496581732581723469864395271712864593953217648145638927679152384328479156",
    d: -5324,
  },
  {
    p: "208000400100040300004003500000080001460070850001002046086415000000009604702006005",
    s: "238567419159248367674193528527684931463971852891352746986415273315729684742836195",
    d: -5532,
  },
  {
    p: "009100060700400031000000280840076012060000400900340006008504009003700040074810623",
    s: "239187564786425931451693287845976312367251498912348756628534179193762845574819623",
    d: -5544,
  },
  {
    p: "039807010047016390060003000000000000600000004070098000020000063390502040506370280",
    s: "239857416847216395165943827952431678681725934473698152724189563398562741516374289",
    d: -5532,
  },
  {
    p: "040008060570046183000003294007000009100000645300002008014000000000700006000600451",
    s: "243198567579246183861573294457861329182937645396452718614385972925714836738629451",
    d: -5324,
  },
  {
    p: "040051073803200009000000000000712036000590007009460000670000090030080740020079650",
    s: "246951873853247169197836524584712936362598417719463285675124398931685742428379651",
    d: -5532,
  },
  {
    p: "240090080300002004860430009103000500090370100706015000670000430001700925950000001",
    s: "247591386319862754865437219183624597594378162726915843672159438431786925958243671",
    d: -5544,
  },
  {
    p: "000000050160000400908402601000020700382100945050809010820905300003000009496000500",
    s: "247691853165783492938452671619524738382167945754839216821975364573246189496318527",
    d: -5322,
  },
  {
    p: "000903051089100000600000070000804007000010004004050013403790100105080702008420000",
    s: "247963851589172436631548279916834527352617984874259613423795168195386742768421395",
    d: -5324,
  },
  {
    p: "008007050036240000000005304004500786000960000800000000900450800400300061650001002",
    s: "248137659536249178719685324194523786372968415865714293921456837487392561653871942",
    d: -5127,
  },
  {
    p: "000003690050040038000600100726894000005000900003050002100508000384960007000030869",
    s: "248713695651249738937685124726894351415327986893156472169578243384962517572431869",
    d: -5114,
  },
  {
    p: "000700050710085200060240010401009080302000105800130000039870000080000000027351800",
    s: "248716953713985264965243718471529386392468175856137492539874621184692537627351849",
    d: -5114,
  },
  {
    p: "209013000003000104510840360070080000900002078850060900190000006700090010006007809",
    s: "249613587683275194517849362372984651961532478854761923195328746738496215426157839",
    d: -5114,
  },
  {
    p: "251304600600007030470100020802600000000200800014000902049050016700060090100000400",
    s: "251394687698527134473186529832649751967215843514873962349758216725461398186932475",
    d: -5532,
  },
  {
    p: "000607390000900415000850060002506100076004000000302086513060000024010600060005901",
    s: "251647398687923415439851267892576134376184529145392786513469872924718653768235941",
    d: -5322,
  },
  {
    p: "050040000009706000006010900360100402004082000000005876020060090603000041000951003",
    s: "251849637439726185786513924368197452574682319912435876125364798693278541847951263",
    d: -5324,
  },
  {
    p: "050006009064500100079800500006102030320608040900000612000001008005000060090067051",
    s: "253716489864529173179834526546192837321678945987345612632451798715983264498267351",
    d: -5114,
  },
  {
    p: "200300001094700058000908030800030100030009200005620300060500000087000094500090800",
    s: "258346971394712658716958432829435167631879245475621389962584713187263594543197826",
    d: -5127,
  },
  {
    p: "208096314900234000003508000320000001000000600705620830000362005030000000602109040",
    s: "258796314917234568463518297326985471891473652745621839174362985539847126682159743",
    d: -5322,
  },
  {
    p: "000080436400000820000000009040805670005070001780060004360009008500030100100542300",
    s: "259187436417396825836254719941825673625473981783961254362719548574638192198542367",
    d: -5532,
  },
  {
    p: "060004005874000000105806000940602703708500904530900000600408000000190286000060001",
    s: "263714895874359612195826347941682753728531964536947128612478539457193286389265471",
    d: -5322,
  },
  {
    p: "000107085000000096390000712830405920100306004000000863002850600507020000000001250",
    s: "264197385751238496398564712836475921129386574475912863912853647547629138683741259",
    d: -5322,
  },
  {
    p: "260307000100260000090805002500900070402600903600008205900000700000720000700109034",
    s: "264397851158264397397815642581932476472651983639478215913546728845723169726189534",
    d: -5532,
  },
  {
    p: "200001470003600800904003005300409008040002301000000054010006007800105000000208049",
    s: "265891473173654892984723615351469728749582361628317954412936587897145236536278149",
    d: -5324,
  },
  {
    p: "067100000580000070009008026000090000704006008090320450630000007001400030000000209",
    s: "267145983583269174149738526315894762724516398896327451632951847971482635458673219",
    d: -5295,
  },
  {
    p: "207003040050700931009000000691004007000000000802300190003001002000045000710632809",
    s: "267193548458726931139458276691584327375219684842367195583971462926845713714632859",
    d: -5532,
  },
  {
    p: "060308010351902004700000920800031409400000600105000000000000100028014307610097000",
    s: "269348715351972864784156923876231459492785631135469278947523186528614397613897542",
    d: -5114,
  },
  {
    p: "000500100840230907030009004000690080300000002026300405003010000002006371407003800",
    s: "269547138845231967731869524154692783378154692926378415683715249592486371417923856",
    d: -5532,
  },
  {
    p: "201350048000000005604000009006008010392401087007500003000003000138605700000100050",
    s: "271359648983246175654817239546738912392461587817592463465973821138625794729184356",
    d: -5532,
  },
  {
    p: "271003450000004780003750001057042000902000074060097000000000800520460300700019000",
    s: "271983456695124783843756921357842169982631574164597238416375892529468317738219645",
    d: -5114,
  },
  {
    p: "000900040086203750000000200002719080019030600700020000001005467840070031007190020",
    s: "273951846186243759594867213652719384419538672738426195921385467845672931367194528",
    d: -5322,
  },
  {
    p: "004300581090050020068070000001695070035001600080000090000900203300010057019000060",
    s: "274369581193458726568172439421695378935781642687234195856947213342816957719523864",
    d: -5532,
  },
  {
    p: "000530600901047000000100000453900008007002514000850903000025100012600000000000326",
    s: "274538691961247835385196742453971268897362514126854973639425187712683459548719326",
    d: -5324,
  },
  {
    p: "270190034900200060010680295007008009000906008002301046000010000105060000063000950",
    s: "276195834958234167314687295637428519541976328892351746489513672125769483763842951",
    d: -5322,
  },
  {
    p: "006000300000000009109000024000680230000093040807004016308700401090200060700400080",
    s: "276941358543862179189375624914687235652193847837524916328756491495218763761439582",
    d: -5127,
  },
  {
    p: "206940015001805009985010400000000602592680001160000000010060000000030054300421000",
    s: "276943815431875269985216437843157692592684371167392548714568923628739154359421786",
    d: -5322,
  },
  {
    p: "000300690000004521104060000002003850006540900000000340605020083080005000720100005",
    s: "278351694369874521154269738942713856836542917517986342695427183481635279723198465",
    d: -5324,
  },
  {
    p: "008603019305200000000007603501000000604000080890400052000750001000002004402006735",
    s: "278643519365219478149587623521378946634925187897461352983754261756132894412896735",
    d: -5532,
  },
  {
    p: "000080100060000490130900007320008000006100030095743001080530010600807300403090050",
    s: "279485163568371492134962587321658974746129835895743621987534216652817349413296758",
    d: -5114,
  },
  {
    p: "270608350000903000350000080040000007720830500005102000067001000030085610100306900",
    s: "279648351418953762356217489843569127721834596695172843567491238932785614184326975",
    d: -5114,
  },
  {
    p: "080300006300200140740081050009610000500000960670490000960020005002040617000700009",
    s: "281354796395267148746981352429615873513872964678493521967128435832549617154736289",
    d: -5114,
  },
  {
    p: "081004000000000012000000360002619008170000500946008200050040103000083025320005080",
    s: "281364957463597812795821364532619748178432596946758231859246173617983425324175689",
    d: -5532,
  },
  {
    p: "000300005547020930300054008095072010000003002000140870000037001970210004003096080",
    s: "281369745547821936369754128895672413714983562632145879428537691976218354153496287",
    d: -5544,
  },
  {
    p: "201560090004093010000200800040000760905046008062000000510900340008600057020070080",
    s: "281567493754893612639214875843152769975346128162789534517928346498631257326475981",
    d: -5114,
  },
  {
    p: "000003961006840503000060007540020000370010600010000050805700049000086205900000800",
    s: "284573961796841523153269487549627318378415692612398754865732149431986275927154836",
    d: -5324,
  },
  {
    p: "200005900907602105503070860005090307029007000730000000800700603601500008000260051",
    s: "286135974947682135513974862465891327129357486738426519852719643671543298394268751",
    d: -5544,
  },
  {
    p: "200001039350000000090060020000000050000040800130092040012006397900704080005020001",
    s: "286471539351289674794365128647138952529647813138592746412856397963714285875923461",
    d: -5127,
  },
  {
    p: "200000000509608000640502800800060009000180030034700000090410750760920140400800006",
    s: "287341965519678324643592871875263419926184537134759682392416758768925143451837296",
    d: -5114,
  },
  {
    p: "000004000000070019410056702008030000500027060603000091000205870002090100005001903",
    s: "287914635356872419419356782128639547594127368673548291931265874842793156765481923",
    d: -5324,
  },
  {
    p: "091400080000021009060800000403080050000107000000003091140630000075012004009050802",
    s: "291476583587321649364895127413289756956147238728563491142638975875912364639754812",
    d: -5324,
  },
  {
    p: "291087365000000120507010480602078500450100076710060003046020050000000014900001000",
    s: "291487365384695127567213489632978541459132876718564293146329758823756914975841632",
    d: -5279,
  },
  {
    p: "090030000307900005800700009520090000910507040078012003100000736605009804700063500",
    s: "291835467367941285854726319526394178913587642478612953149258736635179824782463591",
    d: -5544,
  },
  {
    p: "090075084610294007040010000380002056050086740060050010825000060000021000000060025",
    s: "293675184618294537547813692381742956952186743764359218825937461436521879179468325",
    d: -5544,
  },
  {
    p: "205046071480091000001005429000003900364009000008560207500037000003602700006000300",
    s: "295346871487291653631875429752183964364729518918564237529437186843612795176958342",
    d: -5544,
  },
  {
    p: "200003004000407900400259800700001486046020009901040752000902003020184000109005048",
    s: "295813674318467925467259831732591486546728319981346752854972163623184597179635248",
    d: -5515,
  },
  {
    p: "096078104500312000007906005059000001020000009400080300900103200600000710800000000",
    s: "296578134584312967137946825759234681328651479461789352975163248642895713813427596",
    d: -5127,
  },
  {
    p: "297140030801005040503062810009000380100050260432000000000520100000004008026807000",
    s: "297148536861735942543962817659271384178453269432689751984526173715394628326817495",
    d: -5544,
  },
  {
    p: "007000800005070269040802000060010002002003000008000391000681035056009040309540006",
    s: "297365814835174269641892573963718452412953687578426391724681935156239748389547126",
    d: -5114,
  },
  {
    p: "090000000140086000700934200000095030305001040009000750500010900004378000820049370",
    s: "298157463143286597756934218672495831385721649419863752537612984964378125821549376",
    d: -5114,
  },
  {
    p: "208000100600203080130005204070000400903000012001306507300071000740800020000432900",
    s: "298647153654213789137985264572198436963754812481326597329571648745869321816432975",
    d: -5322,
  },
  {
    p: "090760100100802760376105002000000900502400016960201000030906000010300090400008030",
    s: "298764153154832769376195482741683925582479316963251874837926541615347298429518637",
    d: -5322,
  },
  {
    p: "002006597409007008085000002800060200200598001106700004578640100004000000020079005",
    s: "312486597469257318785931462897164253243598671156723984578642139934815726621379845",
    d: -5544,
  },
  {
    p: "300000004082049030000503721870000050203000060040030009000402905409005600050006003",
    s: "315627894782149536964583721871964352293751468546238179638472915429315687157896243",
    d: -5532,
  },
  {
    p: "005006000000000090820150400000075320270000010950802700004080030108009000502063008",
    s: "315946287647238591829157463481675329276394815953812746764581932138729654592463178",
    d: -5324,
  },
  {
    p: "005900400009030005870005013000006320000713004063092107401600000000001030780000500",
    s: "315978462629134875874265913147586329298713654563492187431657298952841736786329541",
    d: -5532,
  },
  {
    p: "000004528500630000704502000000090007071300200200040806600053012007460300035801000",
    s: "316974528592638471784512693863295147471386259259147836648753912127469385935821764",
    d: -5322,
  },
  {
    p: "000042900006105200285000010000090040000008090198000026700409085530000470800503100",
    s: "317642958946185237285937614652791843473268591198354726761429385539816472824573169",
    d: -5114,
  },
  {
    p: "010605080004008603980003050001306504008002007060790008070009040050067890600801000",
    s: "317645289524918673986273451791386524438152967265794318872539146153467892649821735",
    d: -5544,
  },
  {
    p: "307002450500006930040507208004009001020004069003600024170003000000208000200095103",
    s: "317982456582146937946537218654329781721854369893671524175463892439218675268795143",
    d: -5544,
  },
  {
    p: "000000560002700809000400007800120003040000080025000000030008916006000052950204370",
    s: "317982564462751839598436127879125643143697285625843791234578916786319452951264378",
    d: -5127,
  },
  {
    p: "008270000904000100067000080000124070029307000000000050100930540500010700002080000",
    s: "318279465954863127267541389835124976629357814741698253176932548583416792492785631",
    d: -5295,
  },
  {
    p: "300200657206100300070060020903700500507002010004000000641530200090000430802640090",
    s: "318294657256178349479365821923716584567482913184953762641539278795821436832647195",
    d: -5544,
  },
  {
    p: "018574060002308050705000408007049800096700040850010000580400310420000570000000000",
    s: "318574962942368751765192438137649825296785143854213697589427316421836579673951284",
    d: -5322,
  },
  {
    p: "310400200208370005050002100030685470000000000465700000600107008004009720000030600",
    s: "319456287248371965756892134931685472872914356465723819623147598184569723597238641",
    d: -5532,
  },
  {
    p: "000485000850000304400103000000300200041009060003000500607001482180024639200098100",
    s: "319485726856972314472163958568347291741259863923816547697531482185724639234698175",
    d: -5544,
  },
  {
    p: "009007600002600007600800120035008016020000009706042000063081000008730060170005390",
    s: "319527684582614937647893125435978216821356749796142853963481572258739461174265398",
    d: -5322,
  },
  {
    p: "020000751005030402006024300640058000050010209900000040000067000000005036400300007",
    s: "324689751895731462176524398642958173753416289981273645539167824217845936468392517",
    d: -5127,
  },
  {
    p: "000071006851090000670020000405080007080000053106045020248900360500000000063400705",
    s: "324871596851396274679524138495283617782169453136745829248957361517638942963412785",
    d: -5322,
  },
  {
    p: "000400007048506002600728000400007035800060741100000006206900013010000070037010009",
    s: "325491687748536192691728354462187935853269741179345826286974513914653278537812469",
    d: -5114,
  },
  {
    p: "020060150001509004095007008700680090009370000030000000900018643073090005800200910",
    s: "327864159681529734495137268714685392569372481238941576952718643173496825846253917",
    d: -5322,
  },
  {
    p: "020105600700900008090006507609500002100607003050000100200801905500040706000003040",
    s: "328175694765924318491386527639518472142697853857432169274861935513249786986753241",
    d: -5532,
  },
  {
    p: "008000916100800000094000805000107000740080301016409020000025000070301080905700060",
    s: "328574916157896243694213875283157694749682351516439728861925437472361589935748162",
    d: -5532,
  },
  {
    p: "020051900079034086000800000902307010604000050007500020000410500003065000145002360",
    s: "328651974579234186461879235952347618634128759817596423786413592293765841145982367",
    d: -5322,
  },
  {
    p: "320600510010528370050130068945060120000910045070000930060301082000706003000080601",
    s: "328674519619528374457139268945863127236917845871245936564391782182756493793482651",
    d: -5174,
  },
  {
    p: "020500700108000530700000000000050097907806004080079060074615300690780005013900000",
    s: "329568741148297536756431982261354897937826154485179263874615329692783415513942678",
    d: -5322,
  },
  {
    p: "040759006000400031506300400100570900060094000900180057009800640010600090600000010",
    s: "341759826897462531526318479182573964765294183934186257279831645413625798658947312",
    d: -5114,
  },
  {
    p: "000508600800700090179000000586030070013002000027060038000056082050300006000007153",
    s: "342598617865721394179643825586934271413872569927165438731456982258319746694287153",
    d: -5114,
  },
  {
    p: "000650000057301200961480075030040708000803150508216040084100000610520407000700000",
    s: "342657819857391264961482375136945728429873156578216943784169532613528497295734681",
    d: -5515,
  },
  {
    p: "002076500090000400000009200601040702403005000900000045539081620000093107700000930",
    s: "342876519197532486865419273651348792473925861928167345539781624284693157716254938",
    d: -5114,
  },
  {
    p: "002000650590706300806000009007030120020807000008040070730000590000000730260570841",
    s: "342981657591726384876354219457639128923817465618245973734168592185492736269573841",
    d: -5322,
  },
  {
    p: "005060800900050200000308045027600000006189020090700006704000500800542637000000408",
    s: "345261879981457263672398145427635981536189724198724356764813592819542637253976418",
    d: -5114,
  },
  {
    p: "305692700720005936006000400502063071174080000680500090050000060000706100000900000",
    s: "345692718728145936916378425592463871174289653683517294457821369839756142261934587",
    d: -5322,
  },
  {
    p: "040800700105006028780000060000005030538009002600007081060001200070000000003724800",
    s: "346812795195476328782593164417285639538169472629347581864931257271658943953724816",
    d: -5324,
  },
  {
    p: "300019000590800013102050049071624000000300100003080407006000300715400090030060580",
    s: "348219756597846213162753849871624935924375168653981427486592371715438692239167584",
    d: -5544,
  },
  {
    p: "040005000020610409609004058004062500260459000003070060871500046000146000456007003",
    s: "348795612725618439619234758184362597267459381593871264871523946932146875456987123",
    d: -5515,
  },
  {
    p: "309805000006302004000600030890050260600200800023006795014560008530020006060438000",
    s: "349875612756312984182649537891754263675293841423186795914567328538921476267438159",
    d: -5279,
  },
  {
    p: "050000206900000150008020070000800007000050004089407600020039060700205401030600080",
    s: "351798246972346158648521379413862597267953814589417623824139765796285431135674982",
    d: -5127,
  },
  {
    p: "301800040720000800400010060102045003060030700004007092040650030003000100910000000",
    s: "351876249726394851498512367172945683569238714834167592247651938683429175915783426",
    d: -5127,
  },
  {
    p: "050900070080002500000060104408070005065423000003009607030500400070040010809006752",
    s: "351984276684712539927365184498671325765423891213859647132597468576248913849136752",
    d: -5322,
  },
  {
    p: "354100962708200000002000000009020000270910030080637205807000041020001803140006000",
    s: "354178962718269354962543187539824716276915438481637295897352641625491873143786529",
    d: -5544,
  },
  {
    p: "354670100000490380002030746001057009620000070000060000200046918509800000006029000",
    s: "354678192167492385982135746431257869625981473798364251273546918549813627816729534",
    d: -5544,
  },
  {
    p: "000100000020007900009280000905000060206091048804002195060000001790400002000013659",
    s: "357149826628357914149286537915874263236591748874632195563928471791465382482713659",
    d: -5114,
  },
  {
    p: "058070610000000082260300700870950026920700800005600000000195000590030040601400530",
    s: "358279614719564382264318795873951426926743851145682973437195268592836147681427539",
    d: -5544,
  },
  {
    p: "358007200000000058000018090000006040510073600090000320004000005670000900100300074",
    s: "358947216941632758267518493783296541512473689496851327834729165675184932129365874",
    d: -5490,
  },
  {
    p: "308974000007000039000050000020609080061008000000512640005001308030000060684000790",
    s: "358974216247186539916253874523649187461738952879512643795461328132897465684325791",
    d: -5532,
  },
  {
    p: "359207800008090050407005690000070460100000007805000201703050000080001370000000509",
    s: "359267814618394752427815693932178465146532987875649231793456128584921376261783549",
    d: -5532,
  },
  {
    p: "302000000070023001049670530005834600090016020800090004200000150001247000000080200",
    s: "362451798578923461149678532725834619493716825816592374284369157651247983937185246",
    d: -5114,
  },
  {
    p: "060071590007090600200600030043800100009700380000053000900104070080027450072000809",
    s: "364271598517398642298645731743869125659712384821453967935184276186927453472536819",
    d: -5322,
  },
  {
    p: "305000902004600000090000060138050070057209800000078000006385024583740000000000038",
    s: "365817942274693185891524367138456279457239816629178453916385724583742691742961538",
    d: -5114,
  },
  {
    p: "067000205910030067400002030000003400004006090098007001003070000809000670020809000",
    s: "367198245912534867485762139271983456534216798698457321143675982859321674726849513",
    d: -5127,
  },
  {
    p: "000240510008090002040700900500000740004060053607500100980070005703802000020900000",
    s: "369248517178695432245731968512389746894167253637524189981476325753812694426953871",
    d: -5324,
  },
  {
    p: "309700400020100059501092800000960040006020183010080000080070004002014500600039201",
    s: "369758412827146359541392867238961745496527183715483926183275694972614538654839271",
    d: -5544,
  },
  {
    p: "371060059200590007095700062000006203500000690008020740004000020000080174082070900",
    s: "371264859246598317895731462417956283523847691968123745734619528659382174182475936",
    d: -5544,
  },
  {
    p: "071004908000780041000930000080609030000842006060000805006093084700500009908470000",
    s: "371264958629785341845931267187659432593842176462317895256193784734528619918476523",
    d: -5322,
  },
  {
    p: "001850920980027056500001700152708469708090005040000070800000500017080602000063800",
    s: "371856924984327156526941783152738469738694215649215378863472591417589632295163847",
    d: -5515,
  },
  {
    p: "071906200008074090904208006600000980539800000800403650700609020490080061006040030",
    s: "371956248268174395954238176647521983539867412812493657783619524495382761126745839",
    d: -5515,
  },
  {
    p: "070005896001000304405090201030970000000200013106034089010850600008160030650009108",
    s: "372415896981627354465398271834971562597286413126534789219853647748162935653749128",
    d: -5515,
  },
  {
    p: "002500060080213004000678005040807000800000002206000890500000600968000020023106540",
    s: "372549168685213974491678235149827356837965412256431897514792683968354721723186549",
    d: -5114,
  },
  {
    p: "006090102400003069950001743120307000000004008000010400030000200010702004000109050",
    s: "376495182481273569952861743124387695765924318893516427539648271618752934247139856",
    d: -5324,
  },
  {
    p: "376500000001009500859003006083000400190052060000000015010390750060710803705048600",
    s: "376524189421689537859173246583961472197452368642837915218396754964715823735248691",
    d: -5279,
  },
  {
    p: "309105028050863700000002000030601402020574060060030050010008900083050007090017085",
    s: "379145628152863794648792513935681472821574369764239851517428936283956147496317285",
    d: -5279,
  },
  {
    p: "000080605240006700000590000952000000007000000000750809000038104418070000003060502",
    s: "379482615245316798681597243952841367837629451164753829526938174418275936793164582",
    d: -5490,
  },
  {
    p: "000900400260070000070300682003000050027001003500003207652040300030080024008100590",
    s: "381926475264578139975314682493267851827451963516893247652749318139685724748132596",
    d: -5114,
  },
  {
    p: "380060004506107030000080906137524069048710023050000417800600045073051002000008000",
    s: "382965174596147238714382956137524869648719523259836417821693745973451682465278391",
    d: -5174,
  },
  {
    p: "004002506010700004000000912407005300000300045030964700050600000006401200203080007",
    s: "384192576912756834675843912467215389129378645538964721851627493796431258243589167",
    d: -5532,
  },
  {
    p: "006050974127003056000780030010007009900000003060000710000208500530079020000015040",
    s: "386152974127943856459786132815327469974561283263894715641238597538479621792615348",
    d: -5114,
  },
  {
    p: "380700200000000000005204067500647100004000003820000000700006800200509004609802500",
    s: "386791245472365918915284367593647182164928753827153496751436829238519674649872531",
    d: -5127,
  },
  {
    p: "087019060009000758005700930000407096000001300100000004060004010972105003500930607",
    s: "387519462619342758425786931238457196794621385156893274863274519972165843541938627",
    d: -5544,
  },
  {
    p: "089102070020763001600800003090605000500070410000300056000426907003007000007931060",
    s: "389142675425763891671859243794615382536278419812394756158426937963587124247931568",
    d: -5544,
  },
  {
    p: "390070600000002000004863000050000041040705003810609005001200700000050106735006020",
    s: "392571684586492317174863592657328941249715863813649275961234758428957136735186429",
    d: -5532,
  },
  {
    p: "004070080000013000070600000940107300103000060027830040005709802000580610009020074",
    s: "394275186658413297271698453946157328183942765527836941415769832732584619869321574",
    d: -5114,
  },
  {
    p: "300051700000940000050200030800320510032005408000068000004500320283694000500000800",
    s: "396851742721943685458276931847329516632715498915468273164587329283694157579132864",
    d: -5114,
  },
  {
    p: "008000000651083009702506000036007400000065001080209006900040003800072060000058000",
    s: "398124675651783249742596318536817492279465831184239756927641583815372964463958127",
    d: -5324,
  },
  {
    p: "000600830006000072007000000930000001040009307070823540003952018500070923009400000",
    s: "412697835896345172357281694935764281248519367671823549763952418584176923129438756",
    d: -5114,
  },
  {
    p: "000005007062790000509406021230608075705000006080900200006000000040072000000100350",
    s: "413825697862791534579436821231648975795213486684957213156389742348572169927164358",
    d: -5324,
  },
  {
    p: "008693750000000009090800143921300578504978001070002090100450080080700000709080005",
    s: "418693752352147869697825143921364578564978321873512496136459287285736914749281635",
    d: -5515,
  },
  {
    p: "010007580508019300020000400802740900700050060001008000240100097073804020000000030",
    s: "419237586568419372327685419832746951794351268651928743245163897173894625986572134",
    d: -5532,
  },
  {
    p: "019280050006050400000460103000520630000040000050070940607000014030090080840005060",
    s: "419283756326157498785469123974528631263941875158376942697832514531694287842715369",
    d: -5532,
  },
  {
    p: "010325000850000000236800590390008620600402900024009000903070000102500409065904030",
    s: "419325768857196243236847591391758624678432915524619387943271856182563479765984132",
    d: -5279,
  },
  {
    p: "409672030008000670605300042082051000090800020004030005006080097000926000000040280",
    s: "419672538238415679675398142382751964591864723764239815126583497847926351953147286",
    d: -5322,
  },
  {
    p: "001003090050004238000952064000000001000070920940105800000300042062047309394001780",
    s: "421683597659714238738952164276839451185476923943125876517398642862547319394261785",
    d: -5279,
  },
  {
    p: "400060019017040003800051402000014900008000247090700080741000006003409000280000004",
    s: "425367819917248563836951472672814935158693247394725681741582396563479128289136754",
    d: -5114,
  },
  {
    p: "405080001000051020060200004010009700000648150050000096002004000187000000640000915",
    s: "425986371738451629961237584316529748279648153854713296592164837187395462643872915",
    d: -5324,
  },
  {
    p: "000000003000200001000430020204008136510300008003016042905000200001900305030045070",
    s: "427861953369257481158439627274598136516324798893716542985673214741982365632145879",
    d: -5532,
  },
  {
    p: "420057000603001000000002090007000800501000930900400500079600085154798003036000000",
    s: "428957316693841257715362498347519862581276934962483571279634185154798623836125749",
    d: -5532,
  },
  {
    p: "429000100578000000000092500003007002002183000080000000935000080060035470800019006",
    s: "429358167578461923316792548693547812752183694184926735935674281261835479847219356",
    d: -5324,
  },
  {
    p: "400750000076000080200140350760910025015200000904000130600030000002000600009081000",
    s: "431758269576329481298146357763914825815263794924875136657432918182597643349681572",
    d: -5324,
  },
  {
    p: "002010009080020007006000004390560400050000070000971830000000560070004103901200700",
    s: "432715689589426317716839254397568421158342976624971835843197562275684193961253748",
    d: -5127,
  },
  {
    p: "032708100900200047500000080000007000050901008009030270020500060680000423090400005",
    s: "432798156918256347576314982361827594257941638849635271124583769685179423793462815",
    d: -5324,
  },
  {
    p: "005079068007015290219068000806000539000006070000030040060500000090024000048090020",
    s: "435279168687415293219368457876142539324956871951837642762583914193624785548791326",
    d: -5114,
  },
  {
    p: "400960018080400002070018009007530024593000100020007003060700300008050090000809007",
    s: "435962718189475632276318549817536924593284176624197853962741385748653291351829467",
    d: -5114,
  },
  {
    p: "000020071057000090001053800700504029040130000300000408500400002003070040620310000",
    s: "436829571857641293291753864718564329942138756365297418579486132183972645624315987",
    d: -5324,
  },
  {
    p: "030900020007305001910206030250107300000000100004032700700003080340050270500780003",
    s: "436918527827345961915276834259167348673894152184532796791423685348651279562789413",
    d: -5322,
  },
  {
    p: "437000000000200000120047098209300807040070030750809006001408009800001705500000080",
    s: "437986521985213674126547398219364857648175932753829416371458269892631745564792183",
    d: -5114,
  },
  {
    p: "439100050870903000000574003000600135107085200356010040000000082000002510900851074",
    s: "439128657875963421621574893298647135147385269356219748514736982783492516962851374",
    d: -5515,
  },
  {
    p: "430000000600309008820607030000705400000010270742900005284030090006000542070402080",
    s: "439281657657349128821657934918725463563814279742963815284536791396178542175492386",
    d: -5544,
  },
  {
    p: "430000681600090007027600900000502006010300402070800050100258760000040090000000000",
    s: "439725681681493527527681934943572816815369472276814359194258763368147295752936148",
    d: -5127,
  },
  {
    p: "039068251600952800520040000103504680000806409040079502060200700000000020900480005",
    s: "439768251671952843528341976193524687257836419846179532364215798785693124912487365",
    d: -5515,
  },
  {
    p: "450908276000005000000076084010050600000097030009600058035009801108320000064000300",
    s: "451938276687245913923176584812453697546897132379612458235769841198324765764581329",
    d: -5322,
  },
  {
    p: "000017086007080051900004072600000008508600019000872040020400100010020004094030000",
    s: "453217986267389451981564372642951738578643219139872645725498163316725894894136527",
    d: -5532,
  },
  {
    p: "406702009001090700900001300174856030800000001009000048600200090005100260002600083",
    s: "456732819231498756987561324174856932863924571529317648618273495345189267792645183",
    d: -5322,
  },
  {
    p: "458037160700060002000401308305010400004000700810000950500104000203000810000008000",
    s: "458237169731869542629451378375912486964583721812746953586194237293675814147328695",
    d: -5532,
  },
  {
    p: "008301690067000000003609854029740510000030000000500069090003200046090001130000980",
    s: "458321697967854132213679854629748513571936428384512769795183246846295371132467985",
    d: -5322,
  },
  {
    p: "000300026601000000070058009089002063240000000007010900000009300915203070063004001",
    s: "458391726691427835372658419189742563246935187537816942724169358915283674863574291",
    d: -5324,
  },
  {
    p: "460090570083000041000084000006008000840519632900067100000001000150973060000000003",
    s: "461392578283756941795184326516238497847519632932467185374621859158973264629845713",
    d: -5114,
  },
  {
    p: "061073080000482061002000300300009406000056013006000009070920130020768000800004600",
    s: "461573982539482761782691345358219476947856213216347859674925138123768594895134627",
    d: -5322,
  },
  {
    p: "460005870075106040001007003610802039000003017300700408106000000002519000008000000",
    s: "463295871875136942291487653617842539584963217329751468156328794742519386938674125",
    d: -5114,
  },
  {
    p: "400718000520439000108002003079001308000070905800043007001000090000190050900600034",
    s: "463718529527439681198562473679251348234876915815943267741325896386194752952687134",
    d: -5322,
  },
  {
    p: "005300001708001460090060750002610080010000600800200000040805970307000100609047005",
    s: "465372891728591463193468752932614587514783629876259314241835976357926148689147235",
    d: -5114,
  },
  {
    p: "467000005083705961000600030090000000006958012021000096008501003370860109010037008",
    s: "467319825283745961159682734594126387736958412821473596648591273372864159915237648",
    d: -5515,
  },
  {
    p: "069000050000009678000500000298301000000600020300008009005710000720806490041023700",
    s: "469187352512439678837562914298341567174695823356278149985714236723856491641923785",
    d: -5532,
  },
  {
    p: "000009600260000097095002000008034000030201009506807001087020040009050703150040000",
    s: "471389652263415897895672314918534276734261589526897431387926145649158723152743968",
    d: -5532,
  },
  {
    p: "070620509029400000680570000300000000806750093000086005000000170064030000005004032",
    s: "471623589529418367683579421357942816846751293192386745938265174264137958715894632",
    d: -5324,
  },
  {
    p: "070100300050006700901723408000080100805000930090302086039000004584270003200000800",
    s: "472158369358496721961723458623589147845617932197342586739865214584271693216934875",
    d: -5544,
  },
  {
    p: "470000060965304028001002000238000400004800650600009800709540006516003000040206079",
    s: "472185963965374128381962745238651497194837652657429831729548316516793284843216579",
    d: -5279,
  },
  {
    p: "402100065001007000830540000004803000080000140060471890003910400610304700049720001",
    s: "472189365951637284836542917194863572387295146265471893723916458618354729549728631",
    d: -5279,
  },
  {
    p: "005089006000040070080060409006030000000090082057406031012000000500600124764000500",
    s: "475289316639541278281367459926138745143795682857426931312954867598673124764812593",
    d: -5532,
  },
  {
    p: "070000036062000000000046007039057000005300010140008000204900365000005400700460029",
    s: "478512936562739184913846257839157642625394718147628593284971365396285471751463829",
    d: -5324,
  },
  {
    p: "070951000015627000920030517004090000080005470000004109061040200090213054200500091",
    s: "478951326315627948926438517734192865189365472652874139561749283897213654243586791",
    d: -5515,
  },
  {
    p: "080009000560014080020670005954700060002030048038420950200100870800000094096800030",
    s: "481359627567214389329678415954781263612935748738426951245193876873562194196847532",
    d: -5279,
  },
  {
    p: "400023000390500406075000003024070000710008000006410002067040080140000300900000004",
    s: "481623957392587416675194823524976138719238645836415792267349581148752369953861274",
    d: -5127,
  },
  {
    p: "001900050006180904052607300208700010040060005005090002594003067000000090100000008",
    s: "481932756376185924952647381238754619749261835615398472594823167827416593163579248",
    d: -5532,
  },
  {
    p: "483000020000003600006000093000000007078005001201070000030200400120004508805090732",
    s: "483967125592813674716542893964381257378625941251479386637258419129734568845196732",
    d: -5324,
  },
  {
    p: "400010000200570030071000000500300020738001004040700090903054710100020060000000000",
    s: "485913276296578431371462985519346827738291654642785193923654718154827369867139542",
    d: -5295,
  },
  {
    p: "486000700100605040020080600670034020002000804340000906050276090000500460060000502",
    s: "486321759137695248925487613679834125512769834348152976854276391293518467761943582",
    d: -5322,
  },
  {
    p: "000103609010000000250000310001200083004500201002641000006000030320400970905307020",
    s: "487123659613895742259764318561279483794538261832641597176952834328416975945387126",
    d: -5114,
  },
  {
    p: "089000010030010049000403870608030702051004638000002451590060000000000060010340027",
    s: "489725316735816249162493875648531792251974638973682451594267183327158964816349527",
    d: -5544,
  },
  {
    p: "000007180800009007037001004064005900003004765150700020000000039900843600070000840",
    s: "492357186816429357537681294764235918283914765159768423648172539925843671371596842",
    d: -5114,
  },
  {
    p: "493020600201006000005904802027890040009205000000007023072349050004670009000002000",
    s: "493128675281756394765934812627893541349215768158467923872349156534671289916582437",
    d: -5544,
  },
  {
    p: "400080000000003405005904000000439002240100638057000009031807000500690000806000007",
    s: "493586721682713495715924386168439572249175638357268149931857264574692813826341957",
    d: -5324,
  },
  {
    p: "000000500712093000005000090020040975049000180106009200004031000007600000960472853",
    s: "493768521712593648685214397328146975549327186176859234854931762237685419961472853",
    d: -5322,
  },
  {
    p: "005008060006000038307900502600085200000100850000279613002001306100090405508002190",
    s: "495328761216754938387916542631485279729163854854279613972541386163897425548632197",
    d: -5279,
  },
  {
    p: "400030200320400007651280000000000006006005809700806001960100005500763902002090100",
    s: "497631258328459617651287394185972436246315879739846521963128745514763982872594163",
    d: -5322,
  },
  {
    p: "098650000001473050000180460570000000004030980000000001345007010002010073107000094",
    s: "498652137621473859753189462579841326214736985836295741345967218982514673167328594",
    d: -5114,
  },
  {
    p: "004762003700900500908541002341020050007090001029154000106409005080000006200010048",
    s: "514762983762938514938541672341627859657893421829154367176489235483275196295316748",
    d: -5515,
  },
  {
    p: "004080020700000810038000590040003005006051000380400000003597100050638700890102300",
    s: "514789623729365814638214597941873265276951438385426971463597182152638749897142356",
    d: -5322,
  },
  {
    p: "000000040040608935900050000005000002060205493308740001050000000039507080672830059",
    s: "516973248247618935983452716495361872761285493328749561854196327139527684672834159",
    d: -5544,
  },
  {
    p: "017006900230000006006105078005674000082000490000892000000000000004030009350908020",
    s: "517386942238749516946125378195674283682513497473892165829457631764231859351968724",
    d: -5324,
  },
  {
    p: "010000006006857009407006200260000450901005000040000010070040521090003608000000004",
    s: "519234786326857149487196235268319457931475862745682913673948521194523678852761394",
    d: -5127,
  },
  {
    p: "500020047462005000807904201780210035040080020000007086004700000028001003100000900",
    s: "519328647462175398837964251786219435341586729295437186654793812928641573173852964",
    d: -5322,
  },
  {
    p: "500000700000004002060028009780361000306070200000802600604007805050483100817200003",
    s: "521639748978514362463728519782361954346975281195842637634197825259483176817256493",
    d: -5544,
  },
  {
    p: "521980000008026000300010009010059320085000007000700150009001043860305000003200090",
    s: "521983476798426531346517289617859324485132967932764158259671843864395712173248695",
    d: -5114,
  },
  {
    p: "500006908800029030009000001030801650007500013140063000000940000390000800470030100",
    s: "523416978814729536769385421932871654687594213145263789251948367396157842478632195",
    d: -5532,
  },
  {
    p: "504068000000000005780053042203001004000572000007900500006825407002000309100000080",
    s: "524768931361249875789153642253681794498572163617934528936825417872416359145397286",
    d: -5532,
  },
  {
    p: "024863010960000000001497006000001005050004890000602700000026430030700000602000570",
    s: "524863917967215384381497256473981625256374891198652743719526438835749162642138579",
    d: -5532,
  },
  {
    p: "524986017387240506000700004076090080405000000010050000050008100040502700600079000",
    s: "524986317387241596169735824276193485495827631813654972752368149948512763631479258",
    d: -5544,
  },
  {
    p: "007080016386040002000000530103000600700036821002005047400000100030804000200703004",
    s: "527389416386541792914627538143278659795436821862195347478952163639814275251763984",
    d: -5114,
  },
  {
    p: "027003096000096507046007000000031902295000070001000000600000041008102730710340605",
    s: "527813496183496527946257318864731952295684173371925864639578241458162739712349685",
    d: -5544,
  },
  {
    p: "007000800930400020068372051004100005800705009752600000005060000200034006080000300",
    s: "527916834931458627468372951694183275813725469752649183345261798279834516186597342",
    d: -5532,
  },
  {
    p: "000060490001000706600000215000730040800042007007091560005206370000050600100973050",
    s: "528167493931524786674389215216735948859642137347891562485216379793458621162973854",
    d: -5322,
  },
  {
    p: "000000910009400032630000005000090270490020001005176040000600007806057400702000056",
    s: "528763914179485632634912785361594278497328561285176349953641827816257493742839156",
    d: -5532,
  },
  {
    p: "520041007100000020004050039007000040002034001051060093200870005095426300000503002",
    s: "529341687136987524874652139387195246962734851451268793213879465795426318648513972",
    d: -5544,
  },
  {
    p: "001000004920504030070010000810009002290005000004300910385700620040036008709852103",
    s: "531297864926584731478613295817469352293175486654328917385741629142936578769852143",
    d: -5279,
  },
  {
    p: "500790000720134059900008007002000830350849000000010070673900008040073000209000000",
    s: "531796482728134659964258317192567834357849126486312975673921548845673291219485763",
    d: -5114,
  },
  {
    p: "000060009700002304040001500007235000163008050000610000070000400310090270800073190",
    s: "532467819781952364649381527497235681163748952258619743975126438316894275824573196",
    d: -5532,
  },
  {
    p: "502006910004000500670000000168200000005060070023051804256000081300570000080610003",
    s: "532486917814729536679135248168247395495863172723951864256394781341578629987612453",
    d: -5322,
  },
  {
    p: "500761009908254060000800000015620004200017000760000500020005040051000000097030120",
    s: "532761489978254361146893257315629874284517693769348512623175948451982736897436125",
    d: -5114,
  },
  {
    p: "502007060006321509000560700009003048300000097600040153280030014400080000000412000",
    s: "532897461746321589891564732159673248324158697678249153285736914417985326963412875",
    d: -5544,
  },
  {
    p: "000280000809060030027109500000098002052603000000527160270000300600000009003040005",
    s: "536284917819765234427139586361498752752613498984527163278956341645371829193842675",
    d: -5324,
  },
  {
    p: "500200401040001689010480523200054700004060000073800000307000200000900016000025047",
    s: "538296471742531689916487523291354768854769132673812954367148295425973816189625347",
    d: -5322,
  },
  {
    p: "030900674470800219000006000904108020000604000000700030003089100005007840802000900",
    s: "538912674476853219219476385954138726387624591621795438743589162195267843862341957",
    d: -5532,
  },
  {
    p: "039600087004800961816000040650000004308406009092100000100204300060710008900060012",
    s: "539641287724835961816972543651329874378456129492187635187294356265713498943568712",
    d: -5279,
  },
  {
    p: "539647000000108039700090006065004200000009010290016058940060800650001000007902000",
    s: "539647182426158739781293546165834297873529614294716358942365871658471923317982465",
    d: -5544,
  },
  {
    p: "040702300702000845903456010030270400008040700070015080027000000050104000410807520",
    s: "541782369762391845983456217635278491198643752274915683827569134356124978419837526",
    d: -5279,
  },
  {
    p: "040080020000200503362501000100009070023174058000000190070000845805007030030000061",
    s: "541783926798246513362591487156829374923174658487635192679312845815467239234958761",
    d: -5322,
  },
  {
    p: "042018000080040300000009508000070405020800130704503009003400800056001003090007650",
    s: "542318976987645312361729548839172465625894137714563289273456891456981723198237654",
    d: -5114,
  },
  {
    p: "500800000009000080320096040704005002013000700200400001675321098901000200080007300",
    s: "547813629169742583328596147794135862813269754256478931675321498931684275482957316",
    d: -5114,
  },
  {
    p: "000802600100000400038614900700030140003450020000200009000706210024180003870000000",
    s: "547892631196573482238614957762938145913457826485261379359746218624185793871329564",
    d: -5532,
  },
  {
    p: "540060010072051046600004005004016703009430050010572604000629430000000900096100000",
    s: "548763219972851346631294875254916783769438152813572694185629437427385961396147528",
    d: -5279,
  },
  {
    p: "048000210100085000300200089060000072021560008007409156003090000059740800080000600",
    s: "548976213192385764376214589465831972921567348837429156713698425659742831284153697",
    d: -5322,
  },
  {
    p: "040000030010038000000005200000600479000820060005400003001090780000316902906000005",
    s: "549267138217938654863145297182653479374829561695471823431592786758316942926784315",
    d: -5490,
  },
  {
    p: "002009701004700269100060340490071002300052004200043096020190403743006000000304607",
    s: "562439781834715269179268345495671832386952174217843596628197453743526918951384627",
    d: -5174,
  },
  {
    p: "000934807401570000080200950050740006020600403300020700000401000004067500000090000",
    s: "562934817491578362783216954958743126127685493346129785639451278214867539875392641",
    d: -5324,
  },
  {
    p: "063002040000000607000000329000608005010009000800240090730105902205306074000420538",
    s: "563972841429813657178564329947638215312759486856241793734185962285396174691427538",
    d: -5544,
  },
  {
    p: "500007040004516007070900600000001500798605304050470809007060400905102008020750001",
    s: "569287143384516297172934685243891576798625314651473829817369452935142768426758931",
    d: -5279,
  },
  {
    p: "071002894620000500980105362240000003000608920090000000015007006039206400002000030",
    s: "571362894623489517984175362248791653357648921196523748415937286839216475762854139",
    d: -5544,
  },
  {
    p: "000600980602000300300090002935041207807000000000070000406020031010385426000060050",
    s: "571632984692418375348597612935841267827956143164273598456729831719385426283164759",
    d: -5114,
  },
  {
    p: "570000080060007000000301705007290000000000230003650017000035490900400001405079623",
    s: "571946382362587149894321765147293856659718234283654917726135498938462571415879623",
    d: -5114,
  },
  {
    p: "000000000001009000090047003000964000069070140700210890003000480980000651150698200",
    s: "572386914431529768896147523218964375369875142745213896623751489987432651154698237",
    d: -5114,
  },
  {
    p: "002000410060001000310204670805900130000002000000000720437509201150423090089160045",
    s: "572698413964731582318254679825976134743812956691345728437589261156423897289167345",
    d: -5515,
  },
  {
    p: "500000094000000630080703000007409008840567000600300000200006781700000250038000040",
    s: "573612894921854637486793125317429568842567319695381472254936781769148253138275946",
    d: -5127,
  },
  {
    p: "574600102000000006006372080807000905009560040453920000300250608005000013002013450",
    s: "574689132238145796916372584867431925129568347453927861391254678745896213682713459",
    d: -5515,
  },
  {
    p: "000008910934000002280000040000062581090073006012085300000000030703000098020006150",
    s: "576248913934751862281639745347962581895173426612485379159827634763514298428396157",
    d: -5114,
  },
  {
    p: "508109000000037809000000207010270590095006070287001300000094600006000704000860930",
    s: "578129463462537819139648257614273598395486172287951346853794621926315784741862935",
    d: -5322,
  },
  {
    p: "008004000000089000000000400090060040006943027250100063735090016060850070800006050",
    s: "578324691641589732923617485397265148186943527254178963735492816462851379819736254",
    d: -5532,
  },
  {
    p: "070002001200090003009008004403000600800000005006540038000021000920060147080050392",
    s: "578432961264195783139678524453287619892316475716549238347921856925863147681754392",
    d: -5532,
  },
  {
    p: "000460000600900405000005096300041209000300004184520367700600502230007000001002970",
    s: "579463821612978435843215796356741289927386154184529367798634512235197648461852973",
    d: -5544,
  },
  {
    p: "080000007006040100200900005025170000000002069300000001100086072009010508000704300",
    s: "583621497976845123241937685625179834418352769397468251134586972769213548852794316",
    d: -5490,
  },
  {
    p: "086390007000607080920058600008005462090000730050002091000240000070000004260710008",
    s: "586394217341627589927158643718935462492861735653472891835249176179586324264713958",
    d: -5322,
  },
  {
    p: "500020403000300090904100708002610030370000040600008000709041000005970004003806900",
    s: "586729413217384596934165728452617839378592641691438257769241385825973164143856972",
    d: -5532,
  },
  {
    p: "580301060000004800200060950008700000000030508092058030160900300920010007004005020",
    s: "589321764673594812241867953358746291416239578792158436167982345925413687834675129",
    d: -5532,
  },
  {
    p: "000020046300460070600951000007009000201506030950042600030280000005300408008000300",
    s: "589723146312468975674951283867139524241576839953842617436285791125397468798614352",
    d: -5532,
  },
  {
    p: "091400800060072950000050300400190070050300004000084090000508700700000600620710030",
    s: "591436827364872951287951346436195278859327164172684593943568712715243689628719435",
    d: -5324,
  },
  {
    p: "503020781400109025260000009004000207100000056630200000008703000740000100306940002",
    s: "593426781487139625261578349854691237172384956639257418928713564745862193316945872",
    d: -5322,
  },
  {
    p: "000408006070005003601000007700800600050203700032700080000902075027086010040000000",
    s: "593478126274615893681329457719854632856293741432761589168942375327586914945137268",
    d: -5127,
  },
  {
    p: "003600702060050009000900006000790004084506390070048001057809200010260940006000008",
    s: "593684712762153489841972536635791824184526397279348651457819263318267945926435178",
    d: -5322,
  },
  {
    p: "094102630000976004000000920230000190900003842100009000409007050305020400680500001",
    s: "594182637823976514761345928237468195956713842148259763419837256375621489682594371",
    d: -5544,
  },
  {
    p: "006000008402700009000695320043008000961032800800007000019070400000020180270104000",
    s: "596243718432781569187695324743568291961432875825917643319876452654329187278154936",
    d: -5114,
  },
  {
    p: "596317200002900700103200000041500900007104050950002004614800007009000005000760000",
    s: "596317248482956713173248569241583976367194852958672134614825397729431685835769421",
    d: -5322,
  },
  {
    p: "090008004480607003072000000105804902267030001000006357000980700050700009000450206",
    s: "596328174481697523372145698135874962267539841948216357624981735853762419719453286",
    d: -5544,
  },
  {
    p: "000840030024000860700603050042000000103900026000200403059000307000005209087300610",
    s: "596841732324759861718623954942536178173984526865217493259168347631475289487392615",
    d: -5114,
  },
  {
    p: "590006000400010060030940708053070829000009030908000570074150090000000000010360485",
    s: "597836142482715963136942758653471829721589634948623571374158296865294317219367485",
    d: -5322,
  },
  {
    p: "098012700020000000134000080006800107000005060470009058005027009701900040080000605",
    s: "598412736627583491134796582956834127813275964472169358345627819761958243289341675",
    d: -5532,
  },
  {
    p: "613040027000000000094000065200000030009607054000009600706300010000500006082164570",
    s: "613845927527916348894723165268451739139687254475239681756398412341572896982164573",
    d: -5532,
  },
  {
    p: "010008305200000401000610002031469027729005100005000000352001000040500008180942053",
    s: "614298375298753461573614982831469527729385146465127839352871694947536218186942753",
    d: -5279,
  },
  {
    p: "600000230030004570570000008000071603060450907000006145009760810107000000800302700",
    s: "614587239938624571572139468495871623261453987783296145349765812127948356856312794",
    d: -5322,
  },
  {
    p: "010750000008410000705068000400005000800079462302640958000090380000000129900020007",
    s: "614752893298413675735968214469285731851379462372641958127594386546837129983126547",
    d: -5322,
  },
  {
    p: "610028705000000060735014000170043900000000207400062000040280070900036020000109003",
    s: "614928735298357164735614892172843956863591247459762318341285679987436521526179483",
    d: -5114,
  },
  {
    p: "600000080894102506030008007000040705000516043000000002370020050905700608000604309",
    s: "617395284894172536532468917168243795729516843453987162376829451945731628281654379",
    d: -5322,
  },
  {
    p: "017405008083107040000006710060000073002500801301000400000042506506000007700608000",
    s: "617495328983127645254386719865214973492573861371869452138742596546931287729658134",
    d: -5114,
  },
  {
    p: "017000500000520176000076000930800002470092800000000300052700000309051080706039005",
    s: "617983524893524176524176938931865742475392861268417359152748693349651287786239415",
    d: -5114,
  },
  {
    p: "000050370054600000030008054060509800005103000300826091170000903029307010003091000",
    s: "618954372754632189932718654261549837895173246347826591176485923529367418483291765",
    d: -5544,
  },
  {
    p: "600700023740006090380901056960000570003072000078009100806000205000010600020005340",
    s: "619758423745326891382941756961834572453172968278569134836497215594213687127685349",
    d: -5544,
  },
  {
    p: "023100804798000031105800000500072093069008000300000560000001082004080010010700040",
    s: "623197854798245631145836279581672493469358127372914568957461382234589716816723945",
    d: -5114,
  },
  {
    p: "620103089010000060537600000000810070073024516100005800080430000400200138000001000",
    s: "624153789918742365537698241245816973873924516196375824781439652459267138362581497",
    d: -5322,
  },
  {
    p: "000000040431000800897004020062400300040293010500007092000001200000020074080570930",
    s: "625189743431752869897634125962415387748293516513867492376941258159328674284576931",
    d: -5114,
  },
  {
    p: "000100070079084360034005010002940000390710002040500890280000050907420603400800000",
    s: "625193478179284365834675219512948736398716542746532891281367954957421683463859127",
    d: -5544,
  },
  {
    p: "005407900700003001000090000004060089000502400002004007147309000539006000086100004",
    s: "625417938798253641413698725354761289971582463862934517147329856539846172286175394",
    d: -5324,
  },
  {
    p: "000007810070000002948120705064300900003086520857200130430000251710050000080431600",
    s: "625947813371568492948123765264315987193786524857294136436879251719652348582431679",
    d: -5174,
  },
  {
    p: "627080400008006700109400620900000001400095200300100080890600000700000090050000134",
    s: "627981453548236719139457628965728341481395267372164985894613572713542896256879134",
    d: -5324,
  },
  {
    p: "630054001000020800050069032001032000020005307003900008200103785407000200300200009",
    s: "632854971794321856158769432871632594926485317543917628269143785417598263385276149",
    d: -5322,
  },
  {
    p: "602007158017800900000300006079680510050003004004000300240050000900060005060438000",
    s: "632947158517826943498315726379684512156293874824571369243159687981762435765438291",
    d: -5114,
  },
  {
    p: "030070150007005200900300060308090000005006872060020000080702094000010007006009300",
    s: "634278159817965243952341768328597416495136872761824935183752694249613587576489321",
    d: -5127,
  },
  {
    p: "000021000490086000170000020000000200003019400509460001007003906050804302040000070",
    s: "635721894492386157178945623814537269763219485529468731287153946956874312341692578",
    d: -5127,
  },
  {
    p: "007000015500040027000010600790000081402071300001350000040000009300100752000006003",
    s: "637928415518643927924715638793462581452871396861359274145237869386194752279586143",
    d: -5127,
  },
  {
    p: "600509000010406570000020360980000647004967010100084002042603000090040006060810000",
    s: "638579421219436578457128369983251647524967813176384952742693185891745236365812794",
    d: -5544,
  },
  {
    p: "009205000070400106014000090056800900790040853180900060001004600060029001508006009",
    s: "639215748275498136814763592456832917792641853183957264921384675367529481548176329",
    d: -5544,
  },
  {
    p: "639205010700980006180306209070000130208730060003000007000800001005000670420090080",
    s: "639245718752981346184376259976528134218734965543169827367852491895413672421697583",
    d: -5544,
  },
  {
    p: "640800203003201009709040060006004000070650910000700030408000600030000401005482090",
    s: "641879253583261749729345168356914872872653914914728536498137625237596481165482397",
    d: -5114,
  },
  {
    p: "000100080905080002807604950284500006760008400000090020000017004001000000400000079",
    s: "642159783915783642837624951284571396769238415153496827596817234371942568428365179",
    d: -5127,
  },
  {
    p: "000001907300700410801000005700092000296000004084000392002867000900000000400310500",
    s: "645231987329758416871946235753492861296183754184675392532867149918524673467319528",
    d: -5324,
  },
  {
    p: "049005000010300002302600040031000000006900008008014073795001006000506000160032059",
    s: "649125387517348962382679541231867495476953128958214673795481236823596714164732859",
    d: -5114,
  },
  {
    p: "000000013300000047080004060070000690006708004020006001934605100710049036800230009",
    s: "649587213351962847287314965478153692196728354523496781934675128712849536865231479",
    d: -5322,
  },
  {
    p: "050080003400000710009103000008090006000830009000204000060940032020570400004060980",
    s: "651487293432659718789123654148795326275836149396214875867941532923578461514362987",
    d: -5127,
  },
  {
    p: "050108000340060020000004009008047010060321007007000040070900000120006903493072001",
    s: "652198734349765128781234569938647215564321897217859346876913452125486973493572681",
    d: -5114,
  },
  {
    p: "603128000004609031100005268000093000001000004900401007068002090009800002042030810",
    s: "653128749284679531197345268475293186831567924926481357568712493319854672742936815",
    d: -5544,
  },
  {
    p: "603470000010000000002000030000065300385790641070000500029080406001050800730246000",
    s: "653479218817523964942618735294165387385792641176834592529381476461957823738246159",
    d: -5114,
  },
  {
    p: "600804103208003000030070580023005007000100430941300050009008020370000800080900001",
    s: "657824193298513764134679582823465917765192438941387256419738625376251849582946371",
    d: -5114,
  },
  {
    p: "008070910000500000307090000781020504543007190000000708070060800802140000009008301",
    s: "658274913914536287327891456781923564543687192296415738175362849832149675469758321",
    d: -5114,
  },
  {
    p: "000000000000000650091576008003905060105008043000063205824000001000200090000800432",
    s: "658392714372481659491576328283945167165728943749163285824639571537214896916857432",
    d: -5324,
  },
  {
    p: "600200000071800000008040719000700460040060005360184070780001090904000580000000620",
    s: "659217843471839256238645719192753468847962135365184972786521394924376581513498627",
    d: -5532,
  },
  {
    p: "600020700000070960000060003002100540800009007060032800743006008090708000200013400",
    s: "659321784321874965478965213932187546814659327567432891743296158195748632286513479",
    d: -5324,
  },
  {
    p: "670080009040690003009170020705801400004000800800423095900008064406000200000006950",
    s: "672385149148692573539174628795861432324957816861423795957218364416539287283746951",
    d: -5544,
  },
  {
    p: "672040050004000006058630004000104630040070025793520000000009000000705002060380519",
    s: "672948351314257896958631274285194637146873925793526148521469783839715462467382519",
    d: -5544,
  },
  {
    p: "070000400010846000540000106009050600700680003056200047000170509000003214060000738",
    s: "673915482912846375548732196489357621721684953356291847234178569897563214165429738",
    d: -5322,
  },
  {
    p: "603950002504071000002300000000090230000000061040802970107000500200430706400100309",
    s: "673954182584271693912368457851796234729543861346812975137629548298435716465187329",
    d: -5114,
  },
  {
    p: "000008200510400000089000100807350010005004082940821600050030700798002000230005901",
    s: "674518293512493867389267154827356419165974382943821675451639728798142536236785941",
    d: -5544,
  },
  {
    p: "078040020000957800950062000100000072000306009837200006005030001060010400003009050",
    s: "678143925321957864954862713196485372542376189837291546785634291269518437413729658",
    d: -5532,
  },
  {
    p: "008010094423000051059020080260005000700040100380000000030850017000107005507600809",
    s: "678513294423789651159426783261375948795248136384961572936852417842197365517634829",
    d: -5322,
  },
  {
    p: "609048500034005798205017000000009604060000007007100080308050000006201873721803000",
    s: "679348521134625798285917346812579634563482917947136285398754162456291873721863459",
    d: -5279,
  },
  {
    p: "609400015010200400000901360002130900050700003030590000400810630000600190107000582",
    s: "679483215318265479524971368742138956951726843836594721495812637283657194167349582",
    d: -5544,
  },
  {
    p: "000000200000210087007000690528067019003401060046590032000000050800003006019002008",
    s: "681975243934216587257834691528367419793421865146598732362789154875143926419652378",
    d: -5114,
  },
  {
    p: "600050000034008010105300086008004200097060100000890075800421700040900801700080004",
    s: "682159437934678512175342986568714293397265148421893675853421769246937851719586324",
    d: -5322,
  },
  {
    p: "080003075900000810050706930020601700000800000704002060000240000200500009569018200",
    s: "682193475937425816451786932825631794396874521714952368178249653243567189569318247",
    d: -5532,
  },
  {
    p: "600400509075620300204009080026001007000060813008030052000203070000000200740006000",
    s: "683417529975628341214359786326581497457962813198734652561243978839175264742896135",
    d: -5532,
  },
  {
    p: "000024000040000805071300260204005000000002401760090308007000000000076003406208070",
    s: "683524917942617835571389264214835796398762451765491328157943682829176543436258179",
    d: -5127,
  },
  {
    p: "604100570090480063005796008953007600070000045000900000000000000206030704009070130",
    s: "684123579791485263325796418953247681172368945468951327537614892216839754849572136",
    d: -5114,
  },
  {
    p: "000700000400008607030016540902000006060090001357000009500903060106407200200601000",
    s: "685749312421538697739216548912875436864392751357164829578923164196457283243681975",
    d: -5532,
  },
  {
    p: "009020001410890000003600080270100000301709200058000710132900800890230106000481390",
    s: "689527431415893627723614589276148953341759268958362714132976845894235176567481392",
    d: -5515,
  },
  {
    p: "600007000003000000000060100026871093709050200800020500940016385350402900000009704",
    s: "691347852283195647475268139526871493739654218814923576942716385357482961168539724",
    d: -5322,
  },
  {
    p: "690582030720000000400600080369100004500076010007200600103800960000000000050001740",
    s: "691582437728413596435697182369158274542376819817249653173824965984765321256931748",
    d: -5532,
  },
  {
    p: "603000048070084300000260091800500000000390600059006400004001009100029000925038074",
    s: "693175248271984356548263791836542917412397685759816432364751829187429563925638174",
    d: -5322,
  },
  {
    p: "690040000007005290002000007205800100900100600000006839086050000120708950300000010",
    s: "693247581847615293512389467265893174938174625471526839786951342124738956359462718",
    d: -5324,
  },
  {
    p: "600000000000005002052140860500497236927300001030000050001084509209000000070000020",
    s: "693728145184635792752149863518497236927356481436812957361284579249573618875961324",
    d: -5532,
  },
  {
    p: "694020078027600005030790240003260450052849601000005000008000000206100903000000500",
    s: "694523178827614395135798246983261457752849631461375829518932764246157983379486512",
    d: -5544,
  },
  {
    p: "090703800780026001010000000347600009160070045900080006200100030000000920450000108",
    s: "694713852783526491512849673347651289168972345925384716276198534831465927459237168",
    d: -5532,
  },
  {
    p: "090803201050007040000590008100308509068025004509600000000036000006000000002109436",
    s: "697843251851267943243591678124378569368925714579614382915436827436782195782159436",
    d: -5114,
  },
  {
    p: "690040000007000460010370290045600000009000076076219080002063040700500000000900620",
    s: "698142753237895461514376298845637912129458376376219584982763145761524839453981627",
    d: -5532,
  },
  {
    p: "608250003305000092142000005900520000000471300701009026060930200203000008000600030",
    s: "698257143375164892142893675934526781826471359751389426567938214213745968489612537",
    d: -5322,
  },
  {
    p: "690045003003001700000003050020000090000900004904007080059430607062000045080056930",
    s: "698745213543821769271693458725384196836912574914567382159438627362179845487256931",
    d: -5114,
  },
  {
    p: "700430080000700010068000000080004000537019020009003701690387000023100079000090038",
    s: "712435986954768213368921457186274395537619824249853761695387142823146579471592638",
    d: -5114,
  },
  {
    p: "004000000690000100032071804205000040360090000000032050073005002050006930920000470",
    s: "714289563698453127532671894285167349367594281149832756873945612451726938926318475",
    d: -5324,
  },
  {
    p: "004605000085092000269000040050003008140250063008060000823501007000820500001036080",
    s: "714685329385492176269317845652973418147258963938164752823541697476829531591736284",
    d: -5544,
  },
  {
    p: "010000906350100007908007213005000802001005069480900000039070000806001005000300608",
    s: "714832956352169487968547213695713842271485369483926571539678124846291735127354698",
    d: -5114,
  },
  {
    p: "000000005000000497300000060905024780801500002400786500040001000090078350003002904",
    s: "714869235628315497359247168965124783871593642432786519547931826296478351183652974",
    d: -5532,
  },
  {
    p: "014085026200004090000006107000800910109420003006019002000690201005000000081000700",
    s: "714985326263174598598236147472863915159427683836519472347698251625741839981352764",
    d: -5532,
  },
  {
    p: "016098000000000090002007600800260000030480259090000000068100972100950080020870300",
    s: "716398524385624197942517638851269743637481259294735861568143972173952486429876315",
    d: -5532,
  },
  {
    p: "018000003090068000000003580100600950002030006000584001054000120030410000070850360",
    s: "718245693395768412426193587143627958582931746967584231854376129639412875271859364",
    d: -5532,
  },
  {
    p: "710003000305000100602180009003040001000010632006028407021930045000004000430050060",
    s: "718493526395762184642185379273649851984517632156328497821936745569874213437251968",
    d: -5322,
  },
  {
    p: "009002005802070193003890702031009507285010930974500206000754008020900001007000059",
    s: "719362845862475193453891762631249587285617934974583216196754328528936471347128659",
    d: -5423,
  },
  {
    p: "010003000600200907200000060006009070007080502090010683900540008005802100004001200",
    s: "719463825643258917258197364586329471137684592492715683921546738365872149874931256",
    d: -5324,
  },
  {
    p: "009002040000000281080400900073000062600024809020006410107030690860009003002008100",
    s: "719582346534967281286413975473891562651724839928356417147235698865149723392678154",
    d: -5322,
  },
  {
    p: "009064050360000008025100074040000027000040009008073400403905000106000805002006040",
    s: "719864253364752198825139674641598327237641589958273416483915762196427835572386941",
    d: -5532,
  },
  {
    p: "000805403480702100009041000065018000374050000000000650000580030890007020600004809",
    s: "721895463486732195539641278265918347374256981918473652142589736893167524657324819",
    d: -5114,
  },
  {
    p: "021008000004060209000702031490203000300080590000000004000800406010650003048017000",
    s: "721938645834165279956742831495273168362481597187596324573829416219654783648317952",
    d: -5324,
  },
  {
    p: "703000008000871602680200050100306900470000000390000480500010000800004005010007006",
    s: "723465198945871632681293754158346927472189563396752481534618279867924315219537846",
    d: -5127,
  },
  {
    p: "023581600819000002000093080001000428000000000280006073300179240000600800050028067",
    s: "723581694819764352546293781631957428497832516285416973368179245172645839954328167",
    d: -5544,
  },
  {
    p: "024108060600024790098700020060002507487000230000000809870019052040006003000040601",
    s: "724198365613524798598763124369482517487951236251637849876319452145276983932845671",
    d: -5279,
  },
  {
    p: "000003001350000070691000083270100049000400720000500000080900304100370890000040560",
    s: "724683951358219476691754283275138649813496725469527138587962314146375892932841567",
    d: -5324,
  },
  {
    p: "024800501000500000900200086000010025260009000103600009572008900410000007009172008",
    s: "724836591386591742951247386897314625265789134143625879572468913418953267639172458",
    d: -5114,
  },
  {
    p: "020000904813094002006270000000048107004000039600002400070000321038000506061403008",
    s: "725386914813594672946271853352948167184657239697132485479865321238719546561423798",
    d: -5544,
  },
  {
    p: "005900014401056700000004208800300000000001843006400907048000300010690000507040092",
    s: "725938614481256739693174258874329561259761843136485927948512376312697485567843192",
    d: -5114,
  },
  {
    p: "700000080000096017040708062970065040405070109000000000014020003200601700000503600",
    s: "726134985538296417149758362971365248465872139382419576614927853253681794897543621",
    d: -5532,
  },
  {
    p: "706000053015703400408005000051246070804000002207108500570300080000900200102007305",
    s: "726481953915723468438695721351246879864579132297138546579312684683954217142867395",
    d: -5279,
  },
  {
    p: "720908000000300781000005090000100970400090010009800460570001000692004100001060008",
    s: "726918354954326781183475296865143972437692815219857463578231649692584137341769528",
    d: -5324,
  },
  {
    p: "031060540000134026046007000007341800020000010014020630470600200950400001100890070",
    s: "731268549589134726246957183697341852325786914814529637473615298958472361162893475",
    d: -5279,
  },
  {
    p: "032080100000060083800000000500907006680501027300000451167090000000600300040000619",
    s: "732489165495162783816375294521947836684531927379826451167293548958614372243758619",
    d: -5532,
  },
  {
    p: "704060059008000231000500006401000703090035008000000590300000917849017625000250000",
    s: "734162859568794231912583476451928763297635148683471592325846917849317625176259384",
    d: -5544,
  },
  {
    p: "700210800000009000190004720405080100010642958900570003500096400009100000680027000",
    s: "734215869852769314196834725425983176317642958968571243571396482249158637683427591",
    d: -5544,
  },
  {
    p: "000680009508003000602500008360407980000010045400000300046020090100064007050130260",
    s: "734681529598243671612579438361457982289316745475892316846725193123964857957138264",
    d: -5322,
  },
  {
    p: "000000000100937020290005130020703450000100982659000010007208300040301270010509000",
    s: "735412869186937524294685137821793456473156982659824713567248391948361275312579648",
    d: -5544,
  },
  {
    p: "700060002009130006168700904017040200054023197000000000000004000000000680306205049",
    s: "735469812429138576168752934817946253654823197293571468971684325542397681386215749",
    d: -5114,
  },
  {
    p: "000290050010085090080000004000002410094600007000800060001000300003469000005100982",
    s: "736294158412785693589316724368972415294651837157843269971528346823469571645137982",
    d: -5490,
  },
  {
    p: "008900652000020700040700008024090001100403270003000006050000309300000020069040580",
    s: "738914652915826743642735918524697831196483275873152496451278369387569124269341587",
    d: -5324,
  },
  {
    p: "040389605025170094080050000003021008810640070400000050000500000170004000250800100",
    s: "741389625325176894986452713593721468812645379467938251634517982178294536259863147",
    d: -5114,
  },
  {
    p: "001000008008714000605802000870400100016000007002000643120006000309270004580900302",
    s: "741695238238714956695832471873469125416523897952187643124356789369278514587941362",
    d: -5322,
  },
  {
    p: "002106009003005741000847062096080470000003008000000210000000957670500800050074100",
    s: "742136589863925741519847362396281475127453698485769213234618957671592834958374126",
    d: -5322,
  },
  {
    p: "000001000008420700530900800000006008807203000050010230980074020374080900061009480",
    s: "746831592198425763532967841423596178817243659659718234985174326374682915261359487",
    d: -5322,
  },
  {
    p: "708000000902603400006000100800015640000086005051430090400350080005009700020768004",
    s: "748591263912673458536824179893215647274986315651437892467352981385149726129768534",
    d: -5322,
  },
  {
    p: "000021050002003007003700102800506000009000008637490000906000204000009805205307009",
    s: "748921356192653487563784192821576943459132768637498521976815234314269875285347619",
    d: -5532,
  },
  {
    p: "040000025002000403180000070401980000600020018090617530900100007004305200005070040",
    s: "749836125562791483183452679451983762637524918298617534926148357874365291315279846",
    d: -5114,
  },
  {
    p: "000051600030002070021070009000518200900000060000009300370000851102705940004100730",
    s: "749851623835962174621473589463518297918327465257649318376294851182735946594186732",
    d: -5114,
  },
  {
    p: "700208030000050000000004561030000905400500120125609307540800203007090600003026000",
    s: "751268439364951872892734561638172945479583126125649387546817293287395614913426758",
    d: -5322,
  },
  {
    p: "050028009000130260000409017000000301430700006216093000627900000500306092000000074",
    s: "751628439849137265362459817975864321438712956216593748627941583584376192193285674",
    d: -5322,
  },
  {
    p: "700908000600530000900100080204300000070060503030700020095402008480090152302815079",
    s: "751928346648537291923146785214359867879264513536781924195472638487693152362815479",
    d: -5279,
  },
  {
    p: "051964000049000065800013400400020056060170024000006809002890000000040003500030900",
    s: "751964238349782165826513497418329756965178324273456819632897541197245683584631972",
    d: -5114,
  },
  {
    p: "002080394960024000103970000300010420024000170070000000619007000030000000400651002",
    s: "752186394968324751143975286396718425824563179571492863619237548235849617487651932",
    d: -5532,
  },
  {
    p: "050060009906200800300000002000000500005000900120650004263945780009003400004810000",
    s: "752468139946231857381597642497382516635174928128659374263945781819723465574816293",
    d: -5324,
  },
  {
    p: "000693100310400509809500006000000600600002704107000080971064803280970000065030000",
    s: "752693148316428579849517326534789612698152734127346985971264853283975461465831297",
    d: -5544,
  },
  {
    p: "700000000030786054860095703306810590048300000090060038900008000003201900420050081",
    s: "754132869139786254862495713376814592548329176291567438915648327683271945427953681",
    d: -5279,
  },
  {
    p: "700003010190500400200700560641900080905400020007030900500000000002040190000001035",
    s: "754693218196528473283714569641952387935487621827136954518369742372845196469271835",
    d: -5324,
  },
  {
    p: "001540000080900020020001040810200570000100069300070001600000410108000056902410008",
    s: "761542893483967125529381647816239574274158369395674281637895412148723956952416738",
    d: -5532,
  },
  {
    p: "000905043200003090380400010023080057070050300640007000090268530000700000006500472",
    s: "761925843254813796389476215123684957978152364645397128497268531532741689816539472",
    d: -5322,
  },
  {
    p: "003000008108002069294500000000900007000018003940000005470801306000390000832000910",
    s: "763149528158732469294586731381965247527418693946273185479821356615394872832657914",
    d: -5532,
  },
  {
    p: "763000090100900800008134506000000054002000900009402010080700005027509300005840709",
    s: "763285491154967832298134576671398254542671983839452617986723145427519368315846729",
    d: -5322,
  },
  {
    p: "760000028050002040003400000900640030506010870008075200001006000000000003680920051",
    s: "764591328159832647823467519972648135536219874418375296341756982295184763687923451",
    d: -5324,
  },
  {
    p: "705000802004060950093002700052009086907008020400201000001903678079400200020170009",
    s: "765394812214867953893512764152739486937648125486251397541923678679485231328176549",
    d: -5515,
  },
  {
    p: "700802400000906058020005671001360020000004000000500307900608000003251800000700042",
    s: "765812493134976258829435671581367924397124586246589317912648735473251869658793142",
    d: -5532,
  },
  {
    p: "068000000500001030300950080836709000000028000010040000020080705175203809680000100",
    s: "768432591592871634341956287836719452457328916219645378923184765175263849684597123",
    d: -5532,
  },
  {
    p: "780925040400070900209030007005004008000680104004001200040702380000009070100040000",
    s: "781925643463178925259436817615294738932687154874351296546712389328569471197843562",
    d: -5532,
  },
  {
    p: "000150000600079802100080040006740020007036000098010000520067400071000256904000700",
    s: "782154369645379812139682547316748925257936184498215673523867491871493256964521738",
    d: -5114,
  },
  {
    p: "782000500046250000000008060209000150075000000000501720800000600600100237350607040",
    s: "782416593946253871513798462239874156175962384468531729827349615694185237351627948",
    d: -5532,
  },
  {
    p: "780500030369704000005032080203000900008020050000170000001805007000040100030910805",
    s: "782591634369784512145632789213456978678329451594178263921865347857243196436917825",
    d: -5532,
  },
  {
    p: "080910060015603000400807900008090052059200046020000800060080000001002300003500624",
    s: "782915463915643287436827915348796152159238746627154839264389571571462398893571624",
    d: -5114,
  },
  {
    p: "784001006005700001206009700000800600500003007009000004697015048403600002820000960",
    s: "784321596935786421216549783172854639548963217369172854697215348453698172821437965",
    d: -5322,
  },
  {
    p: "084009130130005090500000000907806400020007060806090070000400300208000014300082056",
    s: "784629135132745698569318247957836421423157869816294573695471382278563914341982756",
    d: -5114,
  },
  {
    p: "005004091190502004426000000007380005800000076000400100000800009900041052570093600",
    s: "785634291193572864426918537617389425834125976259467183342856719968741352571293648",
    d: -5114,
  },
  {
    p: "700009001004070200290030070953180040127900508000057000000200000860093710010006005",
    s: "786429351534671289291835476953182647127964538648357192475218963862593714319746825",
    d: -5322,
  },
  {
    p: "009002304000000000004073080870090506000020807063087000008709000200540710050216098",
    s: "789152364135864279624973185872391546941625837563487921418739652296548713357216498",
    d: -5322,
  },
  {
    p: "000350140002001050001200000800090406164537008923000500007480000000000080050620307",
    s: "789356142642971853531248769875192436164537928923864571217483695396715284458629317",
    d: -5114,
  },
  {
    p: "080030652004690080060075000000006925000000034102040870000763000000000000940210067",
    s: "789431652514692783263875491437186925698527134152349876821763549376954218945218367",
    d: -5532,
  },
  {
    p: "700006850006057102400000076348020001917040005000701004000000000573080200020300010",
    s: "792416853836957142451238976348625791917843625265791384189562437573184269624379518",
    d: -5114,
  },
  {
    p: "700200000000019827100705639007002100029600300600507004230070060906003000071026043",
    s: "793268451564319827182745639357492186429681375618537294235174968946853712871926543",
    d: -5279,
  },
  {
    p: "000060002500000490200905130000740920300000000060080700100000009974002300002000580",
    s: "793461852516328497248975136851746923327519648469283715185634279974852361632197584",
    d: -5295,
  },
  {
    p: "093005180000302000510800036105000023020050700004020800350700204280500310000200950",
    s: "793465182846312579512879436175984623928653741634127895351798264289546317467231958",
    d: -5544,
  },
  {
    p: "000302000000004005153069007007000800628907004010000060000426300300091070560000490",
    s: "794352186286174935153869247437615829628937514915248763879426351342591678561783492",
    d: -5532,
  },
  {
    p: "705004010240008090360000000007401820800700000050000070480005207010087006000040105",
    s: "795234618241568793368179452637451829824793561159826374486915237512387946973642185",
    d: -5324,
  },
  {
    p: "000000260801700390020050000472500010610200050030064700200409608007620530086300000",
    s: "795831264861742395324956187472593816619287453538164729253419678947628531186375942",
    d: -5544,
  },
];
